export class ReqPage { 
    constructor({pageId, pageName, pageDescription, pageLink, menuId, sequence=0}) {
        this.pageId = pageId===undefined?"":pageId
        this.pageName = pageName
        this.pageDescription = pageDescription
        this.pageLink = pageLink
        this.menuId = menuId
        this.sequence = sequence
    }

    fromJson(jsonDate) {
        this.pageId = jsonDate.pageId===undefined?"":jsonDate.pageId
        this.pageName = jsonDate.pageName
        this.pageDescription = jsonDate.pageDescription
        this.pageLink = jsonDate.pageLink
        this.menuId = jsonDate.menuId
        this.sequence = jsonDate.sequence===undefined?0:jsonDate.sequence
    }

    toString() {
        return 'Name: '+this.fullName+', Age:'+this.age
    }
}

export class ReqPageId { 
    constructor({pageLink, menuId}) {
        this.pageLink = pageLink
        this.menuId = menuId
    }

    fromJson(jsonDate) {
        this.pageLink = jsonDate.pageLink
        this.menuId = jsonDate.menuId
    }

    toString() {
    }
}